import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SearchBar from "../../common/components/SearchBar";
import CustomTable from "../../common/table/CustomTable";
import { UsersDataFields, UsersHeadCells } from "./Constants";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";
import { failed, success } from "../../common/Toastify";
import { ArrowBack } from "@mui/icons-material";
import { Tooltip } from "@mui/material"; 
import { Button } from "../../common/Button";
import AddUser from "./AddUser";
import { editGroup } from "../../api/Group";
import { useGroupsQuery } from "../../../hooks/ReactQueryHooks/useGroupsQuery";

const GroupUsersListing = () => {
    let { state } = useLocation();
    const navigate = useNavigate();
    const { getConfirmation } = useConfirmDialog();
    const [filterData, setFilterData] = useState([]);
    const [page, setPage] = useState(0);
    const [deleting, setDeleting] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [groupData, setGroupData] = useState({});
    const [selectedUsers, setSelectedUsers] = useState([]);
    const groupId = state?.id;
    const groupIsDefault = !!state?.isDefault;

    const onGroupSuccess = (data) => {
        if (data) {
            setGroupData(data?.[0]);
            const groupMember = data?.[0].member.map(item => ({
                id: item.entity.reference.split('/')[1],
                name: item.entity.display,
                type: item.entity.type,
                inactive: item.inactive, 
                period: item.period,
                organization: data?.[0]?.organizationName
            })); 
            setSelectedUsers(groupMember) 
        }
    }

    const { isLoading, isFetching, refetch: refetchGroup } = useGroupsQuery({ onSuccess: onGroupSuccess, groupId, refetchOnWindowFocus: false, })

    const handleFilterData = (data) => {
        setFilterData(data);
    };

    const selectedUserAction = ({ action, data }) => { 
        switch (action) {
            case "delete":
                handleDelete(data?.id, data?.name);
                break;
            default:
                return null;
        }
    };

    const handleDelete = async (id, entryName) => {  
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName,
            actionBtnTitle: "Delete",
        });
    
        if (!confirmed) return;
    
        try {
            setDeleting(id); 
            const updatedMembers = selectedUsers
                .filter(user => user.id !== id)
                .map(user => ({
                    entity: {
                        display: user?.name,
                        reference: `${user?.type}/${user?.id}`,
                        type: user?.type
                    },
                    period: user.period,
                    inactive: false
                }));
    
            await editGroup({
                groupId,
                member: updatedMembers,
                quantity: updatedMembers.length,
                orgId: groupData.orgId
            }); 
            success("User Deleted!");
            refetchGroup();
        } catch (err) {
            failed(err?.response?.data?.message || err.message);
        } finally {
            setDeleting(false);
        }
    };
    return (
        <section className="common-listing">
            {showModal
                ? <AddUser
                    modalShow={showModal}
                    refreshTable={refetchGroup} 
                    groupId={groupId}
                    existingGroupMembers={groupData?.member}
                    groupIsDefault={groupIsDefault}
                    groupUsersType={groupData?.type}
                    handleShow={() => setShowModal(false)}
                    orgId={groupData?.orgId}
                    
                /> : null}
            <div className="heading-wrap h-change">
                <Tooltip title="Go back">
                    <div style={{ marginRight: "1rem", cursor: "pointer" }} onClick={() => navigate(-1)}>
                        <ArrowBack />
                    </div>
                </Tooltip>
                <div   style={{ margin: 'right' }}>
                    <h4> {groupData?.name} </h4>
                </div>  
                <div className="right-wrap" style={{ margin: 'left' }}>
                <SearchBar page={page} setPage={setPage} list={selectedUsers} filterData={handleFilterData} encoded={true} /> 
                    <Button isLoading={isLoading || isFetching } onClick={() => setShowModal(true)} className="custom-btn" title="Add Group" style={{ width: 'auto' }}>Add</Button>
                </div>
            </div>
            <CustomTable
                tableData={filterData}
                headCells={UsersHeadCells}
                dataFields={UsersDataFields}
                selectedUserAction={selectedUserAction}
                rowOptions={false}
                loading={isLoading}
                fetching={isFetching}
                deletingItem={deleting}
                canDelete={true}
                canEdit={false}
                page={page}
                setPage={setPage}
            />
        </section>
    );
};

export default GroupUsersListing;
